<template>
  <DpplSkeletonLoader class="line-chart-widget-skeleton">
    <div class="skeleton-body">
      <div class="line-chart-skeleton">
        <LineChartWidgetSkeletonSvg />
      </div>
      <div class="skeleton-axis">
        <v-skeleton-loader
          v-for="(_, k) in Array(11)"
          :key="k"
          type="text"
          width="36px"
        />
      </div>
    </div>
  </DpplSkeletonLoader>
</template>

<script>
import DpplSkeletonLoader from '@/components/datapeople/DpplSkeletonLoader.vue';
import LineChartWidgetSkeletonSvg from '@/assets/line-chart-widget-skeleton.svg?component';

export default {
  name: 'LineChartWidgetSkeleton',
  components: {
    LineChartWidgetSkeletonSvg,
    DpplSkeletonLoader,
  },
};
</script>

<style scoped lang="less">
.line-chart-widget-skeleton {
  height: 100%;
  width: 100%;
}

.skeleton-body {
  height: calc(100% - 17px);
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}
.line-chart-skeleton {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 16px;
}

.skeleton-axis {
  display: flex;
  justify-content: space-between;
  width: 100%;
}

:deep(.v-skeleton-loader__bone) {
  margin: 0 !important;
}
</style>
